module.exports = __webpack_public_path__ + "img/sjds-n.5745d08a.png";